import { currencies } from 'dibs-currency-helpers';

const CURRENCY_STORAGE_KEY = 'userCurrency';

function getCurrencyFromStorage() {
    return (
        localStorage.getItem(CURRENCY_STORAGE_KEY) || sessionStorage.getItem(CURRENCY_STORAGE_KEY)
    );
}

function isValidCurrency(currency) {
    return !!currency && currencies.includes(currency);
}

export function getCurrency({
    currencyQueryParam = null,
    userCurrencyPreference = 'USD',
    regionalInfoCurrency = 'USD',
}) {
    const currencyFromStorage = getCurrencyFromStorage();
    let currency;

    if (currencyQueryParam && isValidCurrency(currencyQueryParam)) {
        // 1) currency query param
        currency = currencyQueryParam;
        sessionStorage.setItem(CURRENCY_STORAGE_KEY, currency);
    } else if (isValidCurrency(userCurrencyPreference)) {
        // 2) logged in user currency preference from service
        currency = userCurrencyPreference;
        localStorage.setItem(CURRENCY_STORAGE_KEY, currency);
    } else if (isValidCurrency(currencyFromStorage)) {
        // 3) currency from local storage
        currency = currencyFromStorage;
    } else if (isValidCurrency(regionalInfoCurrency)) {
        // 4) ip address based regionalInfo currency
        currency = regionalInfoCurrency;
        sessionStorage.setItem(CURRENCY_STORAGE_KEY, currency);
    }

    return currency;
}
